module.exports = __webpack_public_path__ + "assets/img/activityImg2-e1fcd872.png";